<template>
  <div>
    <p></p>
    <div class="box">
      <h3>Please enjoy some Solitude on us. </h3>
      <p>We hope this helps you navigate the <router-link to="/mines">minefield</router-link> of life.</p>
    </div>
    <div class="menu_wrapper">
      <router-link to="/klondike">
        <div class="option">
          <img src="../assets/images/3.png" alt="" srcset="" />

          <p>Klondike Solitaire</p>
        </div>
      </router-link>
      <router-link to="/spider/1">
        <div class="option larger">
          <img src="../assets/images/1.png" alt="" srcset="" />
          <p>Spider Solitaire</p>
        </div>
      </router-link>
      <router-link to="/spider/2">
        <div class="option">
          <img src="../assets/images/5.png" alt="" srcset="" />
          <p>Spider Solitaire [4 Suit]</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style scoped>
</style>
